import request from '@/utils/request'
//新增中台免邮地区
export function freightCreate(data) {
  return request({
    url: '/freight/create',
    method: 'post',
    data: data
  })
}
//修改中台免邮地区
export function freightUpdate(data) {
  return request({
    url: '/freight/update',
    method: 'post',
    data: data
  })
}
// 查询短信渠道（阿里，腾讯，钉钉等）列表
export function freightGet(query) {
  return request({
    url: '/freight/get',
    method: 'get',
    params: query
  })
}
//修改中台免邮地区
export function freightDelete(data) {
  return request({
    url: '/freight/delete',
    method: 'post',
    data: data
  })
}